import { createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { toast } from "react-toastify";

// const BASE_URL = "http://52.2.142.141:8000";
const BASE_URL = "https://api.edubridge.org.uk";

const initialState = {
  isLoading: false,
  profiledata: {},
  cardDetails: [],
  customersubscrip: [],
  cancelcard: [],
  subscriptionProducts: [],
  QuizzData: [],
  listquizs: [],
  viewData: [],
  progressData: [],
  overData: [],
  userToken: [],
  userSettings: [],
  QuizCmsData: [],
  leastdata: {},
  topicdata: []
};

export const globalSlice = createSlice({
  name: "globalSlice",
  initialState,
  reducers: {
    SetLoading: (state, actions) => {
      state.isLoading = actions.payload;
    },
    Profiledetail: (state, actions) => {
      state.profiledata = actions.payload;
    },
    cardDetails: (state, actions) => {
      state.cardDetails = actions.payload;
    },
    customersubscription: (state, actions) => {
      state.customersubscrip = actions.payload;
    },
    cancelcarddetails: (state, actions) => {
      state.cancelcard = actions.payload;
    },
    SetSubscriptionProducts: (state, action) => {
      state.subscriptionProducts = action.payload;
    },
    Quizz: (state, action) => {
      state.QuizzData = action.payload;
    },
    listquiz: (state, action) => {
      state.listquizs = action.payload;
    },
    setAnswer: (state, action) => {
      state.viewData = action.payload;
    },
    setUser: (state, action) => {
      state.progressData = action.payload;
    },
    allData: (state, action) => {
      state.overData = action.payload;
    },
    usetoken: (state, action) => {
      state.userToken = action.payload;
    },
    settingsData: (state, action) => {
      state.userSettings = action.payload;
    },
    quiz: (state, action) => {
      state.QuizCmsData = action.payload;
    },
    least: (state, action) => {
      state.leastdata = action.payload;
    },
    subData: (state, action) => {
      state.topicdata = action.payload;
    },
  },
});

export const {
  SetLoading,
  Profiledetail,
  cardDetails,
  SetSubscriptionProducts,
  cancelcarddetails,
  customersubscription,
  Quizz,
  listquiz,
  setAnswer,
  setUser,
  allData,
  usetoken,
  settingsData,
  quiz,
  subData,
  least,
} = globalSlice.actions;

export default globalSlice.reducer;

const request = (method, nav, path, api, data, func) => {
  return async (dispatch) => {
    try {
      dispatch(SetLoading(true));

      const token = localStorage.getItem('token');

      const response = await axios({
        method,
        url: `${BASE_URL}${api}`,
        data,
        headers: {
          Authorization: token ? `Token ${token}` : '',
        },
      });

      const status = response?.data?.status;

      if (status === 200 || status === 201) {
        dispatch(SetLoading(false));

        if (method === 'get') {
          dispatch(SetLoading(false));
          dispatch(func(response.data));
        } else {
          dispatch(SetLoading(false));
          toast.success(response.data.message)
          nav(path);
        }

        return response.data;
      }

    } catch (error) {
      dispatch(SetLoading(false));
      toast.error(error?.response?.data?.message || 'Something went wrong');
    }
  };
};

export function LoginUser({ loginData, setLoginData, navigate, dispatch }) {
  return async () => {
    try {
      dispatch(SetLoading(true));
      const response = await axios.post(
        `${BASE_URL}/api/user_login`,
        loginData
      );

      if (response?.data?.status === 200) {
        if (response?.data?.two_factor === true) {
          dispatch(SetLoading(false));
          localStorage.setItem("type", "2FA");
          localStorage.setItem("email", loginData?.email);
          setLoginData({ email: "", password: "" });
          navigate("/verifyotp");
          return response?.data;
        } else {
          dispatch(SetLoading(false));
          localStorage.setItem("token", response?.data?.token);
          toast.success(response?.data?.message);
          setLoginData({ email: "", password: "" });
          navigate("/dashboard");
          return response?.data;
        }

      } else {
        dispatch(SetLoading(false));
        toast.error(response?.data?.message);
      }
    } catch (error) {
      toast.error(error?.response?.data?.message);
      dispatch(SetLoading(false));
    }
  };
}

export function RegisterUser({
  signupData,
  setSignupData,
  navigate,
  dispatch,
}) {
  return async () => {
    const formdata = new FormData();
    formdata.append("first_name", signupData.first_name);
    formdata.append("last_name", signupData.last_name);
    formdata.append("email", signupData.email);
    formdata.append("password", signupData.password);
    formdata.append("school_year", signupData.school_year);

    try {
      dispatch(SetLoading(true));
      const response = await axios.post(
        `${BASE_URL}/api/user_register`,
        formdata
      );
      if (response?.status === 201) {
        toast.success(response?.data?.message);
        dispatch(SetLoading(false));
        setSignupData({
          first_name: "",
          last_name: "",
          email: "",
          school_year: "",
          password: "",
        });
        navigate("/");
        return response?.data;
      }
    } catch (error) {
      toast.error(error?.response?.data?.email?.[0]);
      toast.error(error?.response?.data?.[0]);
      toast.error(error?.response?.data?.message);
    } finally {
      dispatch(SetLoading(false));
    }
  };
}

// ------- enter email api ----------------

export function forgotpassword({
  emailData,
  setemailData,
  navigate,
  dispatch,
}) {
  return async () => {
    try {
      dispatch(SetLoading(true));
      const response = await axios.post(`${BASE_URL}/api/send_otp`, emailData);
      if (response?.status === 200) {
        dispatch(SetLoading(false));
        localStorage.setItem("email", emailData?.email);
        toast.success(response?.data?.message);
        setemailData({ email: "" });
        navigate("/verifyotp");
        return response?.data;
      } else {
        dispatch(SetLoading(false));
        toast.error(response?.data?.message);
      }
    } catch (error) {
      toast.error(error?.response?.data?.error);
      dispatch(SetLoading(false));
    }
  };
}

// export function forgotOtp(otp,dispatch) {
//   return async () => {
//     try {
//       dispatch(SetLoading(true));
//       const response = await axios.post(
//         `${BASE_URL}/api/verify_otp`,
//       otp
//       );
//       console.log("response123",response)
//       if (response?.status === 200) {
//         dispatch(SetLoading(false));
//         localStorage.setItem("otp",otp?.otp);
//         toast.success(response?.data?.message);
//       // navigate("/verifyotp")
//         return response?.data;
//       } else{
//         toast.error(response?.data?.error);
//         dispatch(SetLoading(false));
//       }
//     } catch (error) {
//       console.log(error)
//       dispatch(SetLoading(false));
//       toast.error(error?.response?.data?.error);
//       // dispatch(SetLoading(false));
//     }
//   };
// }

// ------- otp api ----------------

export function forgotOtp(otp, navigate, dispatch) {
  return async () => {
    try {
      dispatch(SetLoading(true));
      const response = await axios.post(`${BASE_URL}/api/verify_otp`, otp);

      if (response?.status === 200) {
        dispatch(SetLoading(false));
        toast.success(response?.data?.message);
        if (localStorage.getItem("type") === "forgot") {
          navigate("/newpassword");
        } else {
          localStorage.setItem("token", response?.data?.token);
          navigate("/dashboard");
          localStorage.removeItem("type");
          localStorage.removeItem("email");
        }
        return response?.data;
      } else {
        toast.error(response?.data?.error);
        dispatch(SetLoading(false));
      }
    } catch (error) {
      dispatch(SetLoading(false));
      toast.error(error?.response?.data?.error);
      // dispatch(SetLoading(false));
    }
  };
}

// ------- enter reset password api ----------------

export function resetpaasword({ input, navigate, dispatch }) {
  const email = localStorage.getItem("email");
  const formdata = new FormData();
  formdata.append("email", email);
  formdata.append("new_password", input.new_password);
  return async () => {
    try {
      dispatch(SetLoading(true));
      const response = await axios.post(
        `${BASE_URL}/api/reset_password`,
        formdata
      );
      if (response?.status === 200) {
        dispatch(SetLoading(false));
        toast.success(response?.data?.message);
        localStorage.removeItem("email");
        navigate("/success");
        return response?.data;
      } else {
        dispatch(SetLoading(false));
        toast.error(response?.data?.message);
      }
    } catch (error) {
      dispatch(SetLoading(false));
      toast.error(error?.response?.data?.email?.[0]);
      toast.error(error?.response?.data?.message);
    }
  };
}

// ------- profile api ----------------

export function profileget(dispatch) {
  return async () => {
    let token = localStorage.getItem("token");
    const reqoption = {
      headers: {
        Authorization: `Token ${token}`,
      },
    };
    try {
      dispatch(SetLoading(true));
      const response = await axios.get(
        `${BASE_URL}/api/user_profile`,
        reqoption
      );

      if (response?.status === 200) {
        dispatch(SetLoading(false));
        dispatch(Profiledetail(response?.data));
        return response?.data;
      }
    } catch (error) {
      dispatch(SetLoading(false));
      toast.error(error?.response?.data);
    } finally {
      dispatch(SetLoading(false));
    }
  };
}

// ------- update_profile Api ----------------

export function update_profile({ formData, dispatch }) {
  return async () => {
    let token = localStorage.getItem("token");
    const reqoption = {
      headers: {
        Authorization: `Token ${token}`,
      },
    };
    const formDataToSubmit = new FormData();
    formDataToSubmit.append("first_name", formData.first_name);
    formDataToSubmit.append("last_name", formData.last_name);
    formDataToSubmit.append("email", formData.email);
    formDataToSubmit.append("school_year", formData.school_year);
    if (formData && formData.user_image) {
      const userImage = String(formData.user_image);
      if (userImage.includes("/media")) {
        formDataToSubmit.append("user_image", "");
      } else {
        formDataToSubmit.append("user_image", formData.user_image);
      }
    } else {
      formDataToSubmit.append("user_image", "");
    }
    try {
      dispatch(SetLoading(true));
      const response = await axios.put(
        `${BASE_URL}/api/update_profile`,
        formDataToSubmit,
        reqoption
      );

      if (response?.status === 200) {
        dispatch(SetLoading(false));
        dispatch(profileget(dispatch));
        toast.success(response?.data?.message);
        return response?.data;
      }
    } catch (error) {
      dispatch(SetLoading(false));
      toast.error(error?.response?.data?.user_image?.[0]);
    } finally {
      dispatch(SetLoading(false));
    }
  };
}

// ------------- Change_Password---------------
export function change_password({ input, setInput, navigate, dispatch }) {
  let token = localStorage.getItem("token");
  const reqoption = {
    headers: {
      Authorization: `Token ${token}`,
    },
  };

  const formdata = new FormData();
  formdata.append("old_password", input.old_password);
  formdata.append("new_password", input.new_password);
  return async () => {
    try {
      dispatch(SetLoading(true));
      const response = await axios.post(
        `${BASE_URL}/api/change_password`,
        formdata,
        reqoption
      );
      if (response?.status === 200) {
        setInput({
          old_password: "",
          new_password: "",
        });
        dispatch(SetLoading(false));
        toast.success(response?.data?.message);
        return response?.data;
      } else {
        dispatch(SetLoading(false));
        toast.error(response?.data?.message);
      }
    } catch (error) {
      dispatch(SetLoading(false));
      toast.error(error?.response?.data?.old_password?.[0]);
      toast.error(error?.response?.data?.message);
    }
  };
}

// -------------Create Customer---------------

export function create_customer({ formData, dispatch, setShow, setShowpay, setAutopay }) {

  let token = localStorage.getItem("token");
  const reqoption = {
    headers: {
      Authorization: `Token ${token}`,
    },
  };
  const formdata = new FormData();
  formdata.append("token", formData.token);
  formdata.append("name_on_card", formData.name_on_card);
  formdata.append("line1", formData.line_1);
  formdata.append("postal_code", formData.postal_code);
  formdata.append("country", formData.country);
  return async () => {
    try {
      dispatch(SetLoading(true));
      const response = await axios.post(
        `${BASE_URL}/api/create_customer`,
        formdata,
        reqoption
      );
      if (response?.data?.status === 200) {
        dispatch(card_details({ dispatch, setAutopay }));
        setShowpay(false);
        setShow(false);
        dispatch(SetLoading(false));
        toast.success(response?.data?.message);
        return response?.data;
      } else {
        dispatch(SetLoading(false));
        toast.error(response?.data?.message);
      }
    } catch (error) {
      dispatch(SetLoading(false));
      toast.error(error?.response?.data?.message);
    }
  };
}

// -------buy plan api ----------------

export function buyplan({ price, dispatch, cardDetails, setShow, setLoad }) {
  return async () => {
    let token = localStorage.getItem("token");
    const reqoption = {
      headers: {
        Authorization: `Token ${token}`,
      },
    };
    const formdata = new FormData();
    if (price && cardDetails) {
      formdata.append("price_id", price);
      formdata.append("payment_method_id", cardDetails);
    } else {
      formdata.append("price_id", price);
    }
    try {
      dispatch(SetLoading(true));
      const response = await axios.post(
        `${BASE_URL}/api/subscribe_product`,
        formdata,
        reqoption
      );

      if (response?.status === 200) {
        toast.success(response?.data?.message);
        dispatch(SetLoading(false));
        setLoad(false)
        if (response?.data?.url) {
          window.open(response.data.url, "_blank");
        }
        window.location.reload();
        setShow(false);
        localStorage.removeItem("iddd")
        return response?.data;
      } else {
        dispatch(SetLoading(false));
        toast.error(response?.data?.message);
      }
    } catch (error) {
      dispatch(SetLoading(false));
      toast.error(error?.response?.data?.message);
    }
  };
}

// -------Subscribe product api ----------------

export function fetchSubscriptionProducts() {
  return async (dispatch) => {
    let token = localStorage.getItem("token");
    const reqoption = {
      headers: {
        Authorization: `Token ${token}`,
      },
    };
    try {
      dispatch(SetLoading(true));
      const response = await axios.get(
        `${BASE_URL}/api/stripe_product`,
        reqoption
      );
      if (response?.status === 200) {
        dispatch(SetSubscriptionProducts(response?.data?.message));
        dispatch(SetLoading(false));
        toast.success(response?.data?.message);
        return response?.data;
      } else {
        dispatch(SetLoading(false));
        toast.error(response?.data?.message);
      }
    } catch (error) {
      dispatch(SetLoading(false));
      toast.error(error?.response?.data?.message);
    }
  };
}

//----------fetch the card details-----------

export function card_details({ dispatch, navigate, setAutopay }) {
  return async () => {
    let token = localStorage.getItem("token");
    const reqoption = {
      headers: {
        Authorization: `Token ${token}`,
      },
    };
    try {
      dispatch(SetLoading(true));
      const response = await axios.get(
        `${BASE_URL}/api/stripe_card_details`,
        reqoption
      );

      if (response?.status === 200) {
        dispatch(cardDetails(response?.data.message?.[0]));
        setAutopay(true);
        dispatch(SetLoading(false));
        return response?.data;
      }
    } catch (error) {
      dispatch(SetLoading(false));
      toast.error(error?.response?.data);
    } finally {
      dispatch(SetLoading(false));
    }
  };
}

//----------fetch customer_subscription-----------

export function customer_subscription(dispatch) {
  return async () => {
    let token = localStorage.getItem("token");
    const reqoption = {
      headers: {
        Authorization: `Token ${token}`,
      },
    };
    try {
      dispatch(SetLoading(false));
      const response = await axios.get(
        `${BASE_URL}/api/customer_subscription_details`,
        reqoption
      );

      if (response?.status === 200) {
        let messageData = response?.data?.message;

        if (
          !messageData ||
          messageData === "" ||
          messageData === "User detail not found"
        ) {
          messageData = [];
        }

        dispatch(customersubscription(messageData));
        dispatch(SetLoading(false));
        return response?.data;
      }
    } catch (error) {
      dispatch(SetLoading(false));
      toast.error(error?.response?.data);
    } finally {
      dispatch(SetLoading(false));
    }
  };
}

// -------cancel_subscription api ----------------

export function cancel_subscription({ id, dispatch, setShow }) {
  return async () => {
    let token = localStorage.getItem("token");
    const reqoption = {
      headers: {
        Authorization: `Token ${token}`,
      },
    };
    const formdata = new FormData();
    formdata.append("subscription_id", id);
    try {
      dispatch(SetLoading(true));
      const response = await axios.post(
        `${BASE_URL}/api/cancel_subscription`,
        formdata,
        reqoption
      );
      if (response?.status === 200) {
        dispatch(SetLoading(false));
        toast.success(response?.data?.message);
        setShow(false);
        dispatch(customer_subscription(dispatch));
        return response?.data;
      } else {
        dispatch(SetLoading(false));
        toast.error(response?.data?.message);
      }
    } catch (error) {
      dispatch(SetLoading(false));
      toast.error(error?.response?.data?.message);
    }
  };
}

// --------- Delete card api-------------
export function cancel_card_details({ id, dispatch, setShow }) {
  return async () => {
    let token = localStorage.getItem("token");
    const reqoption = {
      headers: {
        Authorization: `Token ${token}`,
      },
    };
    const formdata = new FormData();
    formdata.append("payment_method_id", id);
    try {
      dispatch(SetLoading(true));
      const response = await axios.request({
        url: `${BASE_URL}/api/stripe_cancel_card_details`,
        method: "DELETE",
        data: formdata,
        headers: reqoption.headers,
      });
      if (response?.status === 200) {
        dispatch(SetLoading(false));
        toast.success(response?.data?.message);
        setShow(false);
        dispatch(card_details({ dispatch }));
        return response?.data;
      } else {
        dispatch(SetLoading(false));
        toast.error(response?.data?.message);
      }
    } catch (error) {
      dispatch(SetLoading(false));
      toast.error(error?.response?.data?.message);
    }
  };
}

//-------------renew_subscription-----------------//

export function renew_subscription({ subid, pay, dispatch }) {
  return async () => {
    let token = localStorage.getItem("token");
    const reqoption = {
      headers: {
        Authorization: `Token ${token}`,
      },
    };
    const formdata = new FormData();
    formdata.append("subscription_id", subid);
    formdata.append("auto_pay", pay);
    try {
      const response = await axios.post(
        `${BASE_URL}/api/customer_subscription_autopay`,
        formdata,
        reqoption
      );
      if (response?.data?.status === 200) {
        toast.success(response?.data?.message);
        dispatch(customer_subscription(dispatch));
        return response?.data;
      } else {
        toast.error(response?.data?.message);
      }
    } catch (error) {
      dispatch(SetLoading(false));
      toast.error(error?.response?.data?.message);
    }
  };
}

//----------paymnet method default-----------//

export function payment_default({ id, dispatch, setShow }) {
  return async () => {
    let token = localStorage.getItem("token");
    const reqoption = {
      headers: {
        Authorization: `Token ${token}`,
      },
    };
    const formdata = new FormData();
    formdata.append("payment_method_id", id);
    try {
      dispatch(SetLoading(true));
      const response = await axios.post(
        `${BASE_URL}/api/customer_default_paymnet`,
        formdata,
        reqoption
      );
      if (response?.status === 200) {
        dispatch(SetLoading(false));
        toast.success(response?.data?.message);
        setShow(false);
        dispatch(customer_subscription(dispatch));
        return response?.data;
      } else {
        dispatch(SetLoading(false));
        toast.error(response?.data?.message);
      }
    } catch (error) {
      dispatch(SetLoading(false));
      toast.error(error?.response?.data?.message);
    }
  };
}

// ------------ generate_quiz Api ----------

export function generate_quiz({ filteroption, navigate, dispatch }) {
  return async () => {
    const token = localStorage.getItem("token");
    const reqoption = {
      headers: {
        Authorization: `Token ${token}`,
      },
    };

    const formdata = new FormData();
    Object.keys(filteroption).forEach((key) => {
      formdata.append(key, filteroption[key]);
    });

    try {
      dispatch(SetLoading(true));

      const response = await axios.post(
        `${BASE_URL}/api/generate_quiz`,
        formdata,
        reqoption
      );
      if (response?.status === 200) {
        localStorage.setItem("id", response?.data?.quiz_id);
        if (localStorage.getItem("id") === null) {
          toast.error("Unexpected error occurred");
          localStorage.removeItem("id")
        } else {
          navigate("/quizz");
        }
        toast.success(response?.data?.message);
        return response?.data;
      }
    } catch (error) {
      dispatch(SetLoading(false));
      toast.error(
        error?.response?.data?.message ||
        "An error occurred while generating the quiz"
      );
    } finally {
      dispatch(SetLoading(false));
    }
  };
}

// --------------------- get quiz data api ------------------------

export function Get_quiz_data({ id, dispatch }) {
  return async () => {
    let token = localStorage.getItem("token");
    const reqoption = {
      headers: {
        Authorization: `Token ${token}`,
      },
    };

    try {
      dispatch(SetLoading(true));
      const response = await axios.get(
        `${BASE_URL}/api/get_quiz?quiz_id=${id}`,
        reqoption
      );
      if (response?.status === 200) {
        dispatch(Quizz(response?.data));
        dispatch(SetLoading(false));
        return response?.data;
      }
    } catch (error) {
      dispatch(SetLoading(false));
      toast.error(error?.response?.data);
    }
  };
}

// ------list_quiz api ----------------

export function list_quiz(dispatch) {
  return async () => {
    let token = localStorage.getItem("token");
    const reqoption = {
      headers: {
        Authorization: `Token ${token}`,
      },
    };

    try {
      dispatch(SetLoading(true));
      const response = await axios.get(`${BASE_URL}/api/list_quiz`, reqoption);
      if (response?.status === 200) {
        dispatch(SetLoading(false));
        dispatch(listquiz(response?.data?.results));
        return response?.data?.results;
      }
    } catch (error) {
      dispatch(SetLoading(false));
      toast.error(error?.response?.results);
    } finally {
      dispatch(SetLoading(false));
    }
  };
}

// ----------------- submit quiz ---------------------------

export function Submitquiz({ userAnswers, dispatch }) {
  let token = localStorage.getItem("token");
  const reqoption = {
    headers: {
      Authorization: `Token ${token}`,
      "Content-Type": "application/json",
    },
  };
  return async () => {
    try {
      dispatch(SetLoading(true));
      const response = await axios.post(
        `${BASE_URL}/api/submit_response`,
        userAnswers,
        reqoption
      );
      if (response?.status === 201) {
        dispatch(SetLoading(false));
        toast.success(response?.data?.message);
        return response?.data;
      }
    } catch (error) {
      dispatch(SetLoading(false));
      toast.error(error?.response?.data?.message);
    }
  };
}

//--------------------View Answer ---------------------------------

export function View_Answer({ id, navigate, dispatch }) {
  return async () => {
    let token = localStorage.getItem("token");
    const reqoption = {
      headers: {
        Authorization: `Token ${token}`,
      },
    };

    try {
      dispatch(SetLoading(true));
      const response = await axios.get(
        `${BASE_URL}/api/fetch_response?quiz_id=${id}`,
        reqoption
      );
      if (response?.status === 200) {
        dispatch(setAnswer(response?.data));
        navigate("/quizquestion")
        dispatch(SetLoading(false));
        return response?.data;
      }
    } catch (error) {
      dispatch(SetLoading(false));
      toast.error(error?.response?.data);
    }
  };
}

//-------------------- User_Progress -----------------
export function User_Progress() {
  return async (dispatch) => {
    let token = localStorage.getItem("token");
    const reqoption = {
      headers: {
        Authorization: `Token ${token}`,
      },
    };
    try {
      dispatch(SetLoading(true));
      const response = await axios.get(
        `${BASE_URL}/api/Progress`,
        reqoption
      );
      if (response?.status === 200) {
        dispatch(SetLoading(false));
        dispatch(setUser(response?.data));
        toast.success(response?.data?.message);
        return response?.data;
      }
    } catch (error) {
      dispatch(SetLoading(false));
      toast.error(error?.response?.data?.message);
    }
  };
}

//----------------Over_all_progress------------------

export function All_Progress() {
  return async (dispatch) => {
    let token = localStorage.getItem("token");
    const reqoption = {
      headers: {
        Authorization: `Token ${token}`,
      },
    };
    try {
      dispatch(SetLoading(true));
      const response = await axios.get(
        `${BASE_URL}/api/all_progress`,
        reqoption
      );
      if (response?.status === 200) {
        dispatch(SetLoading(false));
        dispatch(allData(response?.data));
        toast.success(response?.data?.message);
        return response?.data;
      }
    } catch (error) {
      dispatch(SetLoading(false));
      toast.error(error?.response?.data?.message);
    }
  };
}

//--------------------Review_api-------------------------
export function Review_api({ navigate, quizz, dispatch }) {
  return async () => {
    const token = localStorage.getItem("token");
    const reqoption = {
      headers: {
        Authorization: `Token ${token}`,
      },
    };

    const formdata = new FormData();
    formdata.append("quiz", quizz?.quiz);
    formdata.append("ratings", quizz?.ratings);
    formdata.append("review", quizz?.review);

    try {
      dispatch(SetLoading(true));

      const response = await axios.post(
        `${BASE_URL}/api/review`,
        formdata,
        reqoption
      );
      if (response?.status === 201) {
        dispatch(SetLoading(false));
        toast.success(response?.data?.message);
        navigate('/history')
        return response?.data;
      } else {
        dispatch(SetLoading(false));
        toast.error(response?.data?.message);
      }
    } catch (error) {
      dispatch(SetLoading(false));
      toast.error(error?.response?.data?.message);
    }
  };
}


//----------------user_token------------------

export function user_token() {
  return async (dispatch) => {
    let token = localStorage.getItem("token");
    const reqoption = {
      headers: {
        Authorization: `Token ${token}`,
      },
    };
    try {
      dispatch(SetLoading(true));
      const response = await axios.get(
        `${BASE_URL}/api/user_token`,
        reqoption
      );
      if (response?.data?.status === 200) {
        dispatch(SetLoading(false));
        dispatch(usetoken(response?.data?.data?.[0]));
        toast.success(response?.data?.message);
        return response?.data;
      }
    } catch (error) {
      dispatch(SetLoading(false));
      toast.error(error?.response?.data?.message);
    }
  };
}


// --------------------- user settings update ---------------------
export function user_settings_post({ settingsDetails }) {
  return async (dispatch) => {
    let token = localStorage.getItem("token");
    const reqoption = {
      headers: {
        Authorization: `Token ${token}`,
      },
    };
    const formdata = new FormData();
    formdata.append("daily_reminder", settingsDetails?.daily_reminder);
    formdata.append("plan_renew", settingsDetails?.plan_renew);
    formdata.append("desktop_notification", settingsDetails?.desktop_notification);
    formdata.append("email_notification", settingsDetails?.email_notification);
    formdata.append("appearance", settingsDetails?.appearance);
    formdata.append("two_factor", settingsDetails?.two_factor);
    try {
      dispatch(SetLoading(true));
      const response = await axios.post(
        `${BASE_URL}/api/user_setting`,
        formdata,
        reqoption
      );
      if (response?.data?.status === 200) {
        dispatch(SetLoading(false));
        toast.success(response?.data?.message);
        return response?.data;
      }
    } catch (error) {
      dispatch(SetLoading(false));
      toast.error(error?.response?.data?.message);
    }
  };
}

//--------------------- get user settings ---------------------
export function get_user_settings() {
  return async (dispatch) => {
    let token = localStorage.getItem("token");
    const reqoption = {
      headers: {
        Authorization: `Token ${token}`,
      },
    };
    try {
      dispatch(SetLoading(true));
      const response = await axios.get(
        `${BASE_URL}/api/user_setting`,
        reqoption
      );
      if (response?.data?.status === 200) {
        dispatch(SetLoading(false));
        toast.success(response?.data?.message);
        dispatch(settingsData(response?.data?.data?.[0]))
        return response?.data;
      }
    } catch (error) {
      dispatch(SetLoading(false));
      toast.error(error?.response?.data?.message);
    }
  };
}

//--------------------- cms ---------------------

export function Quizcms() {
  return async (dispatch) => {
    let token = localStorage.getItem("token");
    const reqoption = {
      headers: {
        Authorization: `Token ${token}`,
      },
    };
    try {
      dispatch(SetLoading(true));
      const response = await axios.get(
        `${BASE_URL}/cms/quiz_cms`,
        reqoption
      );
      if (response?.status === 200) {
        dispatch(SetLoading(false));
        dispatch(quiz(response?.data?.data?.[0].response_data))
        return response?.data;
      }
    } catch (error) {
      dispatch(SetLoading(false));
      toast.error(error?.response?.data?.message);
    }
  };
}


// ------least mark api----------------

export function leastapi(dispatch) {
  return async () => {
    let token = localStorage.getItem("token");
    const reqoption = {
      headers: {
        Authorization: `Token ${token}`,
      },
    };

    try {
      dispatch(SetLoading(true));
      const response = await axios.get(`${BASE_URL}/api/least_mark`, reqoption);
      if (response?.status === 200) {
        dispatch(SetLoading(false));
        dispatch(least(response?.data?.results));
        return response?.data?.results;
      }
    } catch (error) {
      dispatch(SetLoading(false));
      toast.error(error?.response?.results);
    } finally {
      dispatch(SetLoading(false));
    }
  };
}


// --------------------- user settings update ---------------------
export function userquery(dispatch, setShow, query) {

  return async () => {
    let token = localStorage.getItem("token");
    const reqoption = {
      headers: {
        Authorization: `Token ${token}`,
      },
    };
    try {
      dispatch(SetLoading(true));
      const response = await axios.post(
        `${BASE_URL}/api/user_query`,
        query,
        reqoption
      );
      if (response?.status === 201) {
        setShow(false);
        dispatch(SetLoading(false));
        toast.success(response?.data?.message);
        return response?.data;
      }
    } catch (error) {
      dispatch(SetLoading(false));
      toast.error(error?.response?.data?.message);
    }
  };
}

//--------------sub-topics

export function Subtopic({ filteroption }) {
  return async (dispatch) => {
    let token = localStorage.getItem("token");
    const reqoption = {
      headers: {
        Authorization: `Token ${token}`,
      },
    };
    try {
      dispatch(SetLoading(true));
      const response = await axios.get(
        `${BASE_URL}/api/subtopic?subject=${filteroption?.subject}&board=${filteroption?.examBoard}`,
        reqoption
      );
      if (response?.status === 200) {
        dispatch(SetLoading(false));
        toast.success(response?.data?.message);
        dispatch(subData(response?.data));
        return response?.data;
      }
    } catch (error) {
      dispatch(SetLoading(false));
      toast.error(error?.response?.data?.message);
    }
  };
}
